import { jsx as _jsx } from "react/jsx-runtime";
import Button from '@mui/material/Button';
import { ActionIcons } from '../../../Iconography';
import { handleLinkSelectedObjects } from './fns/handleLinkSelectedItems';
import { handleAddNewObject } from './fns/handleNewObject';
import { handleUnLinkSelectedObjects } from './fns/handleUnlinkSelectedItems';
/**
 * These have been extracted from Listerlizer to reduce clutter.
 * They are now factory methods - returning a function that will do the same as the original
 * This avoid passing many unrelated attributes around
 */
const debug = process.env.REACT_APP_DEBUG && false;
const commonButtonProps = { variant: 'contained', color: 'primary', size: 'small' };
/** This is not actually added on the new object dialog, its the button that opens the new item dialog. Saving a new object is handled by transactionFunctions, which gets mutated in Listerlizer to deal with listerlizer state */
export const getAddButtonFn = ({ adjacentFilter, matchedPrimary, setNewObject, viewDefinition, disabled }) => () => {
    return (_jsx(Button, { ...commonButtonProps,
        startIcon: _jsx(ActionIcons.Create, {}),
        onClick: () => handleAddNewObject({ setNewObject, adjacentFilter, matchedPrimary, viewDefinition }),
        disabled,
        children: 'Add' }));
};
/** This is actually called the `Link` button */
export const getSearchButtonFn = ({ setShowSearch, showSearch }) => () => {
    return (_jsx(Button, { ...commonButtonProps,
        startIcon: _jsx(ActionIcons.Link, {}),
        disabled: showSearch,
        onClick: () => setShowSearch(!showSearch),
        children: 'Link' }));
};
/**
 * This is actually used in popup dialogs, not button groups (that's the {@link getSearchButtonFn | search button})
 */
export const getLinkButtonFn = ({ createEdgeAdjacentFilter, matchedPrimary, selectedObjects, setShowSearch, transactionFunctions, edgeAttributes }) => () => {
    return (_jsx(Button, { ...commonButtonProps,
        startIcon: _jsx(ActionIcons.Link, {}),
        onClick: () => handleLinkSelectedObjects({
            createEdgeAdjacentFilter,
            matchedPrimary,
            selectedObjects,
            setShowSearch,
            transactionFunctions,
            edgeAttributes,
        }),
        children: 'Link' }));
};
export const getMoveButtonFn = ({ showMoveDialog, setShowMoveDialog, selectedObjects }) => () => {
    debug && console.log(`Returning new getMoveButtonFn with `, { showMoveDialog, selectedObjects });
    return (_jsx(Button, { ...commonButtonProps,
        startIcon: _jsx(ActionIcons.Move, {}),
        onClick: () => setShowMoveDialog(true),
        disabled: showMoveDialog || selectedObjects.length === 0,
        children: 'Move' }));
};
export const getUnlinkButtonFn = ({ adjacentFilter, matchedPrimary, selectedObjects, transactionFunctions }) => () => {
    return (_jsx(Button, { ...commonButtonProps,
        startIcon: _jsx(ActionIcons.Unlink, {}),
        onClick: () => handleUnLinkSelectedObjects({ adjacentFilter, matchedPrimary, selectedObjects, transactionFunctions }),
        disabled: selectedObjects.length === 0,
        children: 'Unlink' }));
};
export const getRemoveButtonFn = ({ selectedObjects, setConfirmation, disabled, loading }) => () => {
    return (_jsx(Button, { ...commonButtonProps,
        color: 'error',
        startIcon: _jsx(ActionIcons.Delete, {}),
        onClick: () => setConfirmation(true),
        disabled: disabled || selectedObjects.length === 0,
        loading,
        children: 'Remove' }));
};
